import React from "react";
import { X } from "lucide-react";
import OrderSummary from "./OrderSummary";

const BasketModal = ({
  open,
  onClose,
  lines,
  subtotal,
  notice,
  onRemove,
  onQtyChange,
  onCheckout,
}) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[80] bg-black/55 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Your basket"
      data-testid="basket-modal"
    >
      <div className="relative w-full max-w-lg max-h-[90vh] overflow-y-auto rounded-lg">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white/95 border border-[#d9c3a8] text-[#9b3d0a] flex items-center justify-center shadow-sm"
          aria-label="Close basket"
        >
          <X size={18} />
        </button>

        <OrderSummary
          lines={lines}
          subtotal={subtotal}
          notice={notice}
          onRemove={onRemove}
          onQtyChange={onQtyChange}
          onCheckout={onCheckout}
          checkoutLabel="CONTINUE TO CHECKOUT"
        />
      </div>
    </div>
  );
};

export default BasketModal;
